module.exports = __webpack_public_path__ + "static/img/loading.fa54e1a0.gif";